import React, { Component } from 'react';
import { message } from 'antd';

if (!window.rmes) window.rmes = {}

window.rmes.message = message